<template>
    <div  class="addlabel">
        <div class="page" style="height:100%">
            <div style="margin-bottom: 8px;margin-top: 10px;">
                <span>我的标签</span>
                <span style="color:gray;margin-left:5px">(最多可添加10个)</span>
                <span style="float: right;cursor: pointer;" @click="close()"><img src="../assets/image/close.png"></span>
            </div>
            <div>
                <ul >
                    <li v-for="(item,index) in ShowTagsList" class="lablewords" @click="CheckTags(item.Name)" :class="{active:activeList.includes(item.Name)}"><span>{{item.Name}}</span></li>
                </ul>
            </div>
            <div>
                <input type="text" title="关键词" class="input" style="width: 70%;margin-top: 5px;background-color: white;" 
                @ placeholder="请输入新标签" v-model="keyword" @keyup.enter="addtags">
                <button class="btn" @click="addtags()" style="position: relative;margin-left: 5px;padding: 0 15px;">确认</button>
            </div>
            <div v-if="errormsg" style="margin-top: 10px; color:red;">
                {{errormsg}}
            </div>
            <div style="margin-bottom: 20px;">
                <button @click="SetTagName()" class="btn selfbtn">确认</button><button @click="close();" class="btn selfbtn cancelbtn">取消</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    componentName: "LabelList",
    props: {
        did:Number,
        pid:Number,
        savetags:Array,
    },
    watch:{
        keyword(newVal){
            if(newVal.length>4){
                 this.errormsg='标签最长4个字'
                 this.keyword=this.keyword.substring(0,4);
                setTimeout(() => {
                    this.errormsg='';
                }, 2000);
            }
        }
    },
    data(){
        return{
            keyword:'',
            SendTags:[],
            activeList:[],
            checkactiveList:[],
            errormsg:'',
            addtstatus:false,
            tagsnum:0
        }
    },
    computed: {
        token:{
            get(){
                return this.$store.state.menu.token
            },
            set(val){
                this.$store.state.menu.token = val
            }
        },
        ShowTagsList:{
            get(){
                return this.$store.state.sofasniper.ShowTagsList
            },
            set(val){
                this.$store.state.sofasniper.ShowTagsList = val
            }
        },
    },
    methods:{
        close(){
           this.$emit("listenTochildEvent",false);
        },
        SetTagName(){
            let tags='';
            for(let item of this.activeList)
            {
                if(tags=='')
                {
                    tags=item;
                }
                else
                {
                    tags=tags+'|'+item;
                }
            }
            
            if(!this.addtstatus){
                this.close();
            }
            else{
                this.$messenger.addTarget(window.parent, 'parent');
                let sendmsg={token:this.token,projectid:this.pid,dataid:this.did,tagname:tags};
                this.$messenger.targets['parent'].send("Sofa_Sniper_Send_Tag_Message",sendmsg);
                this.errormsg='标签设置成功！'
                this.$emit("listenTagsEvent",{did:this.did,tags:tags});
                setTimeout(() => {
                    this.errormsg='';
                }, 2000);
                this.close();
            }
            this.addtstatus=false;
        },
        // GetProjectTag(){
        //     this.$messenger.addTarget(window.parent, 'parent');
        //     let sendmsg={token:this.token,projectid:this.pid}
        //     this.$messenger.targets['parent'].send("Sofa_Sniper_Send_Project_Tag_Message",sendmsg);
        // },
        taglistening(){
 
            // this.GetProjectTag();

            this.activeList=this.savetags;

            // this.$messenger.listen("_5118_Sofa_Sniper_GetProject_Tag_info", (msg) => {
            //     if(msg)
            //     {
            //         this.ShowTagsList=JSON.parse(msg);
            //         if(msg.indexOf('已作答')==-1){
            //             this.ShowTagsList.push({Name:'已作答'});
            //         }
            //         if(msg.indexOf('不相关')==-1){
            //             this.ShowTagsList.push({Name:'不相关'});
            //         }
                    
            //     }
            // });
        },
        addtags(){
            if(this.keyword=='')
            {
                this.errormsg='标签不能为空'
                setTimeout(() => {
                    this.errormsg='';
                }, 2000);
                return
            }
            if(this.ShowTagsList.length>=10)
            {
                this.keyword='';
                this.errormsg='已经超出10个标签'
                setTimeout(() => {
                    this.errormsg='';
                }, 2000);
                return
            }
            this.ShowTagsList.push({Name:this.keyword});

            if(this.activeList.includes(this.keyword)){
               let index = this.activeList.indexOf(this.keyword)
               index!=-1 && this.activeList.splice(index,1)
            }else{
                this.activeList.push(this.keyword);
            }

            this.addtstatus=true;
            
            this.keyword='';
        },
        CheckTags(name){
            this.addtstatus=true;
            if(this.activeList.includes(name)){
               let index = this.activeList.indexOf(name)
               index!=-1 && this.activeList.splice(index,1)
            }else{
                this.activeList.push(name);
            }
            
        },
        cancel(){
            this.activeList = [];
        }

    },
    mounted() {
        
        setTimeout(() => {
            this.taglistening();
        }, 1500);
        
    }
}
</script>

<style type="text/less" lang="less" scoped>
  @import "../assets/style/color";
  @import "../assets/style/config";
  @import "../assets/style/mixin";

  .addlabel{
        position:absolute;
        background-color: #ddedfb;
        height:auto; max-height:350px;
        z-index: 1;
        img{
            width: 15px;
            height: 15px;
            position:relative;
            margin-top: 2px;
            margin-left: -2px
        
        }
        .lablewords{
            color: black;
            background-color: white;
            padding: 5px 15px;
            border-radius: 3px;
            margin-right: 5px;
            display:inline-block;
            margin-bottom:10px;
            cursor: pointer;
            &.active{
                background-color: #f49307;
                color: white;
            }
            
        }
        .selfbtn{
            padding: 3px 30px;
            margin-left: 20px;
            margin-top: 20px
        }
        .cancelbtn{
            background-color: white;
            color: #166df1;
            border: 1px solid #166df1;
        }
        
    }

</style>


// WEBPACK FOOTER //
// src/components/LabelList.vue